import BlackFridayModal from 'src/components/Promotions/BlackFriday/BlackFridayModal.svelte';
import { PROMOTIONS } from 'src/constants';
import { profile_data } from 'src/stores/account/user';
import { get } from 'svelte/store';

export const BlackFridayPhase2Config = (forceShow = false) => ({
	id: 'blackFridayPhase2',
	component: BlackFridayModal,
	props: {
		showModal: true,
		priority: 100, // Highest priority
		phase: 2,
	},
	rules: [
		{
			check: () => {
				const now = new Date().getTime();
				return (
					now >= PROMOTIONS.BLACK_FRIDAY_PHASE_2.START_DATE &&
					now < PROMOTIONS.BLACK_FRIDAY_PHASE_2.END_DATE &&
					(!get(profile_data)?.promotions?.blackFridayPhase2 || forceShow)
				);
			},
			expected: true,
		},
	],
});
